export const OFFICER = 'officer'
